/** 农事记录详情页文案 */
export const recordDetailsZh = {
    workName: "农事名称",
    expand: "展开",
    collapse: "收起",
    scienceLabel: "科普知识：",
    phenotypeLabel: "表型特征：",
    highRiskLabel: "高发区域：",
    harmLevelLabel: "危害等级：",
    anomalyLevelLabel: "异常等级：",
    growthAbnormalBanner: "点击记录长势异常动态",
    growthAbnormalBannerDesc: "生成精细处方图",
    growthAbnormalRecord: "点击记录",
    growthAbnormalTypeLabel: "请选择发生的异常类型",
    growthAbnormalTypePlaceholder: "请选择异常类型",
    growthAbnormalTypeRequired: "请选择异常类型",
    farmAnalysisLabel: "农情研判：",
    patrolLabel: "巡园要点：",
    growthQuestion: "果径是否显著小于正常果，且果皮失去光泽、呈现暗哑状态？",
    pestQuestion: "蒂蛀虫、荔枝蝽蟓、炭疽病、霜疫霉病",
    phenologyQuestion: "果实是否开始由扁圆变圆、横径明显增大？",
    growthScience:
        "当前荔枝处于果实膨大期，近期存在强降水和强对流天气频发的情况，且当前识别到阴雨气象风险较高3级，累计阴雨天数达12天、日均湿度约91%。连续阴雨导致光照不足，月累计日照时数较常年偏少17%，叶片光合效率下降，碳水化合物合成减少",
    growthPhenotype:
        "果实膨大速度慢，果皮颜色黄绿、光泽度差，严重时果面出现细微水裂纹；萎蔫时叶片下垂卷曲；缺氮时老叶均匀黄化；缺钾时老叶叶缘焦枯；缺镁时老叶叶肉黄化、叶脉仍绿；缺钙时果实易裂果；缺硼时果实发育不良、果皮木栓化；缺锌时果实大小不均；缺铁时新叶黄白失绿",
    growthHighRisk:
        "重点巡视低洼地、排水不畅的粘重土壤果园，以及树冠中下部及内膛果实。观察果实膨大进度，对比不同方位果穗大小差异；观察叶片萎蔫程度和黄化部位。拔根检查根系状态——砂土看根系是否偏白不烂，黏土看是否发软发臭，酸性土看根尖是否膨大变黑，盐碱土看是否被泥浆包裹，重金属土看是否发黑有异味，荔枝土看根尖是否变黑腐臭。根系受损时先排水松土养根，暂不施根肥，叶面维持，等新根萌发后再施根肥。发现异常症状后请拍照上传，及时存档。",
    pestScience:
        "当前荔枝处于果期，预测田间病虫害气象风险2级，近期湿度达88%、日均气温达30℃，该环境条件十分有利于害虫活动和病原菌侵染。果期是荔枝产量形成的关键阶段，幼果皮层薄嫩、抗逆性弱，一旦遭受蒂蛀虫、荔枝蝽象、霜疫霉病、炭疽病等主要病虫为害，将直接导致落果、烂果，严重影响产量和品质。需抓紧巡园，同步做好虫情、病情的动态监测，防范风险升级。",
    phenologyAnalysis:
        "膨果期果实开始横向生长，由扁圆形逐渐转为圆球形，是果肉细胞快速分裂膨大和干物质积累的关键阶段，氮和钾需求双高。氮促进果肉细胞分裂膨大，钾促进光合产物转运和糖分积累。此时养分供应不足会导致果实膨大受阻、单果重偏低，需及时根部追肥保障果实发育。",
    phenologyPhenotype:
        "果实由扁圆形开始横向增宽，果皮青绿色有光泽，果实横径明显增大，果肩逐渐饱满。\n巡园要点：重点观察树冠外围中上部结果枝，检查果实形状变化和横径大小，统计进入快速膨大的果实比例。拍照记录果实膨大状态，上传存档。",
    tabFruitBlocked: "膨果受阻",
    tabSlowGrowth: "长势缓慢",
    tabVigorous: "植株旺长",
    tabWilting: "叶片萎蔫",
    drawTip: "点击勾画新发生区域",
    notReached: "暂未到达进程",
    confirmUpload: "确认上传",
    keyAssessment: "关键防治需肥期评估：",
    phenologyIssue: "是否有60%的荔枝进入膨果期?",
    currentStatus: "当前现状：当前{label}进入到{period}",
    uploadPhoto: "点击上传照片",
    confirmInfo: "点击记录巡园照片",
    abnormalBanner: "点击记录病虫害动态",
    abnormalBannerDesc: "生成精细处方图",
    abnormalRecord: "AI 识别",
    partitionBannerTitle: "物候不整齐?",
    partitionBannerDesc:
        "如果区域长势不同，会降低病虫害防治功效，建议根据长势拆分区域，进行分区精细管理，达到减药减肥的目的",
    partitionManage: "分区管理",
    abnormalCount: "每 20 棵树中，有几棵出现了 病虫异常？",
    treeUnit: "棵",
    inputPlaceholder: "请输入",
    ratioRequired: "请输入占比",
    patrolDesc: "巡园描述",
    inputDescPlaceholder: "请输入描述",
    uploadPhotoFirst: "请先上传照片",
    drawMapFirst: "请先勾画地图区域",
    confirmSuccess: "确认成功",
    pestDisease: "病害",
    pestInsect: "虫害",
    catDiseaseFungal: "真菌型",
    catDiseaseBacterial: "细菌型",
    catDiseaseSoilBorne: "土传型",
    catDiseaseInsectBorne: "虫传型",
    catDiseaseViral: "病毒型",
    catInsectPiercing: "刺吸式",
    catInsectChewing: "咀嚼式",
    catInsectBoring: "钻蛀式",
    catInsectUnderground: "地下害虫",
    detDownyMildew: "霜疫霉病",
    detAnthracnose: "炭疽病",
    detBlast: "叶瘟",
    detSheathBlight: "纹枯病",
    detStinkBug: "荔枝蝽象",
    detRiceBorer: "二化螟",
    detStemBorer: "蒂蛀虫",
    pestT1_downy:
        "果实感病后出现水渍状褪绿斑块，湿度大时表面产生白色霜状霉层，后病部变褐软腐，果实腐烂脱落。膨大期至转色期果实感病后病斑扩展迅速，果肉褐变腐烂，有酸臭味，病果易脱落。",
    pestT2_downy:
        "重点巡查果园低洼积水处、密蔽通风不良处的果穗，观察果实表面有无水渍状褪绿斑块，清晨或雨后湿度大时查看病斑表面有无白色霜状霉层，用手轻捏感病果实检查是否软腐，闻有无酸臭味。发现病斑后请拍照上传，及时存档，便于记录发生程度与防控节点。",
    pestT1_anthracnose:
        "果实感病后出现暗褐色水渍状斑点，后扩展为圆形或不规则形黑褐色凹陷病斑，边缘明显，湿度大时病斑表面出现粉红色黏稠孢子堆。病斑深入果肉导致腐烂，病果干缩后挂在枝头不脱落形成僵果。",
    pestT2_anthracnose:
        "重点巡查树冠内膛及下部枝条的果穗，观察果实表面有无暗褐色至黑褐色凹陷病斑，病斑边缘是否清晰，在湿度大的清晨查看病斑表面有无粉红色黏稠物。注意与霜疫霉病区分：炭疽病病斑凹陷干缩，霜疫霉病病部湿软腐烂。发现病斑后请拍照上传，及时存档，便于记录发生程度与防控节点。",
    pestT1_stinkbug:
        "成虫和若虫刺吸幼果和嫩梢汁液，受害果实出现褐色坏死斑点，果实发育受阻、果形不正，严重时幼果大量脱落。成虫体长约25mm、黄褐色盾形，受惊时释放臭液；若虫体色鲜红至橙红，群集为害。",
    pestT2_stinkbug:
        "重点巡查树冠中上部外围果穗集中处，观察果实和果梗上是否有黄褐色盾形成虫或红色群集若虫。轻摇枝条看是否有成虫受惊飞逃，同时闻是否有刺激性臭味。发现为害状及活虫后请拍照上传，及时存档，便于记录发生程度与防控节点。",
    pestT1_stemborer:
        "成虫为小型蛾类，幼虫钻蛀果实，从果蒂附近蛀入果心，蛀食果核和果肉，造成果实内部充满虫粪。受害果实外表初期无明显异常，后期果蒂周围变黑、果实提前着色变红脱落（\"红果\"现象），落果剖开可见幼虫及虫粪。",
    pestT2_stemborer:
        "重点巡查树冠内膛和下垂枝的果穗，注意捡拾地面落果，剖开检查果核周围有无幼虫和虫粪。观察树上果实有无果蒂变黑、提前转红的异常果。成虫调查时，在晨昏成虫活动期用手掌用力拍打树冠内膛的枝干，观察是否有小蛾受惊飞出，以此判断成虫发生密度。关键防治节点需通过收集落果观察蛹的羽化进度来确定打药时机。发现为害状及活虫后请拍照上传，及时存档，便于记录发生程度与防控节点。",
    pestT1_riceborer: "幼虫钻蛀稻茎基部，造成枯心苗，受害株心叶变黄枯死，茎秆基部有圆形蛀孔及虫粪排出，轻拔枯心苗易折断，断口可见幼虫或虫道",
    pestT2_riceborer:
        "重点巡查田间分散出现的枯心团或枯心带，沿行间逐株检查心叶是否变黄萎蔫。拔取枯心株，用刀片或指甲剥开茎秆基部，检查内部有无淡褐色或灰白色幼虫、虫粪及蛀道。发现为害状及活虫后请拍照上传，及时存档，便于记录发生程度与防控节点",
};

export const recordDetailsEn = {
    workName: "Farm Work",
    expand: "Expand",
    collapse: "Collapse",
    scienceLabel: "Science: ",
    phenotypeLabel: "Phenotype: ",
    highRiskLabel: "High-risk areas: ",
    harmLevelLabel: "Damage level: ",
    anomalyLevelLabel: "Abnormality level: ",
    growthAbnormalBanner: "Record growth anomaly updates",
    growthAbnormalBannerDesc: "Generate prescription map",
    growthAbnormalRecord: "Record",
    growthAbnormalTypeLabel: "Select abnormality type",
    growthAbnormalTypePlaceholder: "Select abnormality type",
    growthAbnormalTypeRequired: "Please select abnormality type",
    farmAnalysisLabel: "Assessment: ",
    patrolLabel: "Patrol points: ",
    growthQuestion:
        "Is fruit diameter significantly smaller than normal, with dull, lackluster skin?",
    pestQuestion: "Stem borer, lychee stink bug, anthracnose, downy mildew",
    phenologyQuestion: "Are fruits changing from flat-round to round with clearly increased equatorial diameter?",
    growthScience:
        "Lychee is in fruit expansion. Recent heavy rain and convection weather are frequent; rainy weather risk is level 3 with 12 rainy days and ~91% humidity. Low light reduced monthly sunshine by 17% vs normal, lowering photosynthesis and carbohydrate synthesis.",
    growthPhenotype:
        "Slow fruit expansion, yellow-green dull skin, fine cracks when severe; wilting leaves curl down; N deficiency yellows old leaves evenly; K burns leaf margins; Mg yellows leaf blade; Ca causes cracking; B poor fruit set; Zn uneven fruit size; Fe bleaches new leaves.",
    growthHighRisk:
        "Patrol low-lying poorly drained orchards and inner-canopy fruit. Compare fruit size by aspect; check wilting and chlorosis. Root checks by soil type. After root damage: drain, loosen soil, foliar care first, root fertilizer after new roots. Photograph and archive abnormalities.",
    pestScience:
        "Lychee in fruit stage; field pest weather risk level 2; humidity 88%, ~30°C favor pests and pathogens. Fruit stage is critical; thin skin is vulnerable to stem borer, stink bug, downy mildew, anthracnose — causing drop and rot. Intensify scouting and monitoring.",
    phenologyAnalysis:
        "Fruit expands horizontally from flat-round toward round; rapid cell division and dry matter accumulation; high N and K demand. Insufficient nutrients limit sizing — apply root fertilizer timely.",
    phenologyPhenotype:
        "Fruit widens horizontally, glossy green skin, shoulders fill out.\nPatrol: outer upper fruiting branches; track shape and equatorial diameter; photo and upload.",
    tabFruitBlocked: "Expansion blocked",
    tabSlowGrowth: "Slow growth",
    tabVigorous: "Vigorous growth",
    tabWilting: "Leaf wilting",
    drawTip: "Tap to draw new affected area",
    notReached: "Stage not reached",
    confirmUpload: "Confirm upload",
    keyAssessment: "Key nutrition & control assessment: ",
    phenologyIssue: "Have 60% of lychee trees entered fruit expansion?",
    currentStatus: "Status: {label} entered {period}",
    uploadPhoto: "Upload photos",
    confirmInfo: "Tap to record patrol photos",
    abnormalBanner: "Tap to record pest and disease dynamics",
    abnormalBannerDesc: "Generate precision prescription maps",
    abnormalRecord: "AI Recognition",
    partitionBannerTitle: "Uneven phenology?",
    partitionBannerDesc:
        "If growth varies by area, pest control is less effective. Split zones by vigor for precision management to reduce pesticide and fertilizer use.",
    partitionManage: "Zone management",
    abnormalCount: "Out of every 20 trees, how many show pest/disease abnormality?",
    treeUnit: "trees",
    inputPlaceholder: "Enter",
    ratioRequired: "Please enter the ratio",
    patrolDesc: "Patrol notes",
    inputDescPlaceholder: "Enter description",
    uploadPhotoFirst: "Please upload photos first",
    drawMapFirst: "Please draw the area on the map first",
    confirmSuccess: "Confirmed",
    pestDisease: "Disease",
    pestInsect: "Insect",
    catDiseaseFungal: "Fungal",
    catDiseaseBacterial: "Bacterial",
    catDiseaseSoilBorne: "Soil-borne",
    catDiseaseInsectBorne: "Insect-borne",
    catDiseaseViral: "Viral",
    catInsectPiercing: "Piercing-sucking",
    catInsectChewing: "Chewing",
    catInsectBoring: "Boring",
    catInsectUnderground: "Underground pests",
    detDownyMildew: "Downy mildew",
    detAnthracnose: "Anthracnose",
    detBlast: "Blast",
    detSheathBlight: "Sheath blight",
    detStinkBug: "Lychee stink bug",
    detRiceBorer: "Rice stem borer",
    detStemBorer: "Litchi stem borer",
    pestT1_downy:
        "Infected fruit shows water-soaked light-green patches; white downy mold in high humidity, then brown soft rot and drop. Rapid spread in expansion to color-change stage.",
    pestT2_downy:
        "Patrol low, humid, poorly ventilated clusters; check water-soaked patches and morning mold; squeeze fruit for soft rot and sour smell. Photograph and archive.",
    pestT1_anthracnose:
        "Dark brown water-soaked spots expand to sunken anthracnose lesions with pink spore masses in humidity; flesh rots; mummified fruit may remain on tree.",
    pestT2_anthracnose:
        "Patrol inner and lower clusters for sunken dark lesions; distinguish from downy mildew (soft rot vs sunken dry lesions). Photograph and archive.",
    pestT1_stinkbug:
        "Adults and nymphs suck young fruit and shoots; brown necrotic spots, misshapen fruit, heavy drop. Adults ~25 mm tan shield-shaped; nymphs orange-red in groups.",
    pestT2_stinkbug:
        "Patrol upper outer fruiting zones for shield bugs or red nymph masses; shake branches and note odor. Photograph and archive live insects and damage.",
    pestT1_stemborer:
        "Small moth larvae bore from stem end into seed cavity; frass inside fruit; late red premature fruit drop.",
    pestT2_stemborer:
        "Patrol inner canopy and hanging clusters; collect dropped fruit and split for larvae/frass; check stem-end blackening. Photograph and archive.",
    pestT1_riceborer: "Larvae bore rice stems at base causing dead hearts with bore holes and frass.",
    pestT2_riceborer: "Patrol dead-heart patches; split stem bases for larvae, frass, and tunnels. Photograph and archive.",
};
